module.exports = __webpack_public_path__ + "img/sceneImg.caf1003d.jpg";